import React, { createContext, useReducer } from 'react'

const FormDataContext = createContext()

const initialState = {
  id: '',
  nome: '',
  gain: 0,
  components: [],
  price: 0,
  rival: 0,
  quantidade: 1,
  unidade: 'Uni',
  cost_unique: 0,
  cost: 0,
}

function formReducer(state, action) {
  switch (action.type) {
    case 'SET_FORM_DATA':
      return action.formData
    case 'UPDATE_FORM_FIELD':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'CLEAR_FORM':
      return initialState
    default:
      return state
  }
}

export function FormDataProvider({ children }) {
  const [values, dispatch] = useReducer(formReducer, initialState)
  console.log(values)
  const clearForm = () => dispatch({ type: 'CLEAR_FORM' })

  const setFormData = (formData) => dispatch({ type: 'SET_FORM_DATA', formData })

  const updateFormField = (field, value) => dispatch({ type: 'UPDATE_FORM_FIELD', field, value })

  return (
    <FormDataContext.Provider value={{ values, setFormData, updateFormField, clearForm }}>
      {children}
    </FormDataContext.Provider>
  )
}

export default FormDataContext
